/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/{id}/apiconnection
 */
export interface ApiconnectionRequestBuilder extends BaseRequestBuilder<ApiconnectionRequestBuilder> {
    /**
     * DisconnectApiCharger
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<ApiconnectionRequestBuilderDeleteQueryParameters> | undefined) : Promise<void>;
    /**
     * DisconnectApiCharger
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<ApiconnectionRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
}
/**
 * DisconnectApiCharger
 */
export interface ApiconnectionRequestBuilderDeleteQueryParameters {
    deleteOAuthConnection?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const ApiconnectionRequestBuilderUriTemplate = "{+baseurl}/chargepoints/{id}/apiconnection{?deleteOAuthConnection*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ApiconnectionRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: ApiconnectionRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
